let localAnalyticsEnabled;
let localProduct;
let webStorageControlsEnabled;
let localConsentModeEnabled;
export const getBscGlobalState = () => {
  var _localConsentModeEnab;
  if (localAnalyticsEnabled == null) {
    localAnalyticsEnabled = true;
  }

  // Unless specified, localConsentMode is turned off
  localConsentModeEnabled = (_localConsentModeEnab = localConsentModeEnabled) !== null && _localConsentModeEnab !== void 0 ? _localConsentModeEnab : false;
  return {
    analyticsEnabled: localAnalyticsEnabled,
    product: localProduct,
    webStorageEnabled: webStorageControlsEnabled,
    localConsentMode: localConsentModeEnabled
  };
};
export const initializeGlobalState = ({
  analyticsEnabled = true,
  product = 'NONE',
  webStorageEnabled = false,
  localConsentMode = false
} = {}) => {
  localAnalyticsEnabled = analyticsEnabled;
  localProduct = product;
  webStorageControlsEnabled = webStorageEnabled;
  localConsentModeEnabled = localConsentMode;
};
export const clearGlobalState = () => {
  localAnalyticsEnabled = undefined;
  localProduct = undefined;
};